import type { ReactNode } from 'react';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  title: string;
  // Optional right-side controls (filter field, search, or action button).
  children?: ReactNode;
}

// Shared header for settings/bookings section pages. Owns the headline and a
// fixed min-height so the headline-to-content spacing stays identical whether
// the right-side control is a tall filter field or a short button.
export const SectionHeader = ({ title, children }: SectionHeaderProps) => (
  <div className={styles.header}>
    <h2 className={styles.heading}>{title}</h2>
    {children}
  </div>
);
